import { Stack, Text } from "@mantine/core"
import { Missing } from "@tfg/ui"

import { LibraryResponses } from "@tfg/types/endpoints/library"

import { CopyToClipboard } from "~/components/CopyToClipboard"
import { CountryCell } from "~/components/cells/CountryCell"
import { useAuth } from "~/store/auth-context"

type Props = {
  supplier?: LibraryResponses.Product["lastPendingIrContact"]
}

export const LastPendingIrContactCell = ({ supplier }: Props) => {
  const { isAdmin } = useAuth()

  return supplier ? (
    <Stack gap={0}>
      <Stack gap={0} align="left">
        {supplier.confidential && !isAdmin ? (
          <Missing />
        ) : (
          <CopyToClipboard
            text={supplier.email ?? ""}
            color={supplier.confidential ? "violet" : undefined}
            style={{ cursor: "pointer", textDecoration: "underline" }}
          />
        )}
      </Stack>
      <Stack gap={0} fz="xs" c="var(--mantine-color-gray-6">
        <Text fz="xs">{supplier.company.name}</Text>
        <CountryCell countryIso3166={supplier.company.country} />
      </Stack>
    </Stack>
  ) : (
    <Missing />
  )
}
